import Header from "~components/Header"
import * as Styled from './styled'
import { Outlet } from "react-router-dom"

function Layout() {
  return (
    <Styled.Layout role="region">
      <Header />
      <Styled.MainContent><Outlet /></Styled.MainContent>
    </Styled.Layout>
  )
}

export default Layout